import { MainPath } from "Constants/constants";
import { getCartIdFromCookie } from "Utils/cookies/cookiesUtil";
import { withoutProductEditParams } from "Utils/navigation/queryParameterUtils";
import { useHistory } from "react-router";

export const useCheckPriceRedirectToCartCallback = (): (() => void) => {
  const history = useHistory();
  const cartIdFromCookie = getCartIdFromCookie();

  return () => {
    const redirectUri = `/${MainPath.OFFER}/${cartIdFromCookie}`;
    history.push({
      pathname: redirectUri,
      search: withoutProductEditParams(history.location.search).toString(),
    });
  };
};
